if (!customElements.get('manual-bis')) {
  customElements.define(
    'manual-bis',
    class ManualBis extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.form.addEventListener('submit', this.submitHandler.bind(this));

        this.triggerBtn = document.querySelector('#Manual-bis-btn');
        this.triggerBtn && this.triggerBtn.addEventListener('click', this.open.bind(this));

        this.querySelectorAll('#manual-bis [data-close-modal]').forEach((btn) =>
          btn.addEventListener('click', this.close.bind(this))
        );

        this.productData = this.getProductData();
        this.notify();
      }
      open() {
        this.querySelector('.js-manual-popup').classList.remove('hidden');
        this.querySelector('.manual-bis-message').textContent = '';
        this.querySelector('.manual-bis-success').classList.add('hidden');
      }
      close() {
        this.querySelector('.js-manual-popup').classList.add('hidden');
      }
      notify() {
        const dataBadge = JSON.parse(document.querySelector('#data-badge[type="application/json"]').textContent);
        const productData = this.productData;
        let listThreshold = dataBadge.blocks.filter((block) => block.type === 'sold_out_threshold');

        const toggleShowKlaviyo = (elm) => {
          let currentVariant = JSON.parse(elm.dataset.currentVariant);
          if (!currentVariant) {
            return;
          }
          this.querySelector('#manual-bis-variant')
            ? (this.querySelector('#manual-bis-variant').value = currentVariant.id)
            : null;
          this.querySelector('.manual-bis-popup__variant')
            ? (this.querySelector('.manual-bis-popup__variant').textContent = currentVariant.title)
            : null;

          let matchThreshold = listThreshold.filter((threshold) =>
            productData.tags.includes(threshold.settings.handle)
          );
          let thresholdQuantityList = matchThreshold.map((value) => value.settings.number);
          let currentVariantAvailable = currentVariant.available;
          if (!currentVariantAvailable) {
            elm.classList.remove('hidden');
            return;
          }
          let currentVariantSoldOut = thresholdQuantityList.some((i) => i >= currentVariant.inventory_quantity);
          if (currentVariantSoldOut) {
            elm.classList.remove('hidden');
            elm
              .closest('.shopify-section')
              .querySelector('variant-radios')
              .toggleAddButton(true, window.variantStrings.soldOut);
          } else {
            elm.classList.add('hidden');
            elm
              .closest('.shopify-section')
              .querySelector('variant-radios')
              .toggleAddButton(false, window.variantStrings.addToCart);
          }
        };

        if (this.triggerBtn) {
          toggleShowKlaviyo(this.triggerBtn);

          let observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
              if (mutation.type === 'attributes' && mutation.attributeName === 'data-current-variant')
                toggleShowKlaviyo(mutation.target);
            });
          });
          observer.observe(this.triggerBtn, {
            attributes: true,
          });
        }
      }
      submitHandler(e) {
        e.preventDefault();
        e.submitter.classList.add('loading');
        this.querySelector('.manual-bis-message').textContent = '';
        this.querySelector('.manual-bis-success').classList.add('hidden');
        const formData = new FormData(this.form);
        fetch(`https://a.klaviyo.com/onsite/components/back-in-stock/subscribe`, {
          method: 'POST',
          body: formData,
        })
          .then((response) => response.json())
          .then((response) => {
            console.log(response);
            if (response.message) {
              this.querySelector('.manual-bis-message').textContent = response.message;
            }
            if (response.success) {
              this.querySelector('.manual-bis-success').classList.remove('hidden');
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            e.submitter.classList.remove('loading');
          });
      }

      getProductData() {
        this.productData =
          this.productData || JSON.parse(this.querySelector(`#ProductInfoScript--ManualBis`).textContent);
        return this.productData;
      }
    }
  );
}
